import { ResourceModel } from '@bryntum/schedulerpro'

export function vehicleAvatarSorter(item1: ResourceModel, item2: ResourceModel) {
  const vehicleAvatar1 = item1.getData(
    'vehicleAvatar',
  ) as uui.domain.client.rm.SchedulerResource['vehicleAvatar']

  const vehicleAvatar2 = item2.getData(
    'vehicleAvatar',
  ) as uui.domain.client.rm.SchedulerResource['vehicleAvatar']

  return vehicleAvatar1 - vehicleAvatar2
}
